// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3IAg4","subheader":"ReorderModal_subheader__2Alpw","listWrap":"ReorderModal_listWrap__1T9DO"};